import * as React from "react";
import { Button } from "react-bootstrap";

const styles = require("./styles.module.scss");

interface CustomPopoverProps {
  style?: any;
  showColumn: Function;
  hideColumn: Function;
  displayText: Function;
  saveSettings: Function;
  resetSettings: Function;
  clearSettings: Function;
  onMouseLeave: (event) => void;
  shownColumns: string[];
  hiddenColumns: string[];
}

const CustomPopover: React.FunctionComponent<CustomPopoverProps> = props => {
  const {
    style,
    onMouseLeave,
    shownColumns,
    hideColumn,
    hiddenColumns,
    showColumn,
    displayText,
    saveSettings,
    resetSettings,
    clearSettings,
  } = props;

  return (
    <div
      onMouseLeave={onMouseLeave}
      className={styles.columnPicker}
      style={{
        ...style,
      }}
    >
      <h2 className={styles.heading}>Displayed columns</h2>
      <ul>
        {shownColumns.map(column => (
          <li key={column}>
            {props.displayText(column)}
            <i className="fa fa-close" onClick={() => hideColumn(column)} />
          </li>
        ))}
      </ul>
      <hr className={styles.horizontalDivider} />
      <h2 className={styles.heading}>Available columns</h2>
      <ul>
        {hiddenColumns.map(column => (
          <li key={column} onClick={() => showColumn(column)}>
            {displayText(column)}
          </li>
        ))}
      </ul>
      <hr className={styles.horizontalDivider} />
      <h2 className={styles.heading}>Default column settings</h2>
      <div className={styles.columnSettings}>
        <Button bsSize="small" className="btn btn-link" onClick={saveSettings}>
          Save column settings as default
        </Button>
        <Button bsSize="small" className="btn btn-link" onClick={resetSettings}>
          Reload default column settings
        </Button>
        <Button bsSize="small" className="btn btn-link" onClick={clearSettings}>
          Clear default column settings
        </Button>
      </div>
    </div>
  );
};

export default CustomPopover;
